import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);
import _ from "lodash";
import cf from "@/helpers/conf";
import fn from "@/helpers/func";
import "moment/locale/ka";
import "moment/locale/en-au";
import "moment/locale/en-ca";
import "moment/locale/en-gb";
// import stack from './demo/stack_basic'
import PortalVue from "portal-vue";
import { Tabs } from "vue-slim-tabs";
import SlideUpDown from "vue-slide-up-down";
Vue.component("slide-up-down", SlideUpDown);
Vue.use(Tabs);
Vue.use(PortalVue);
import ElementUI from "element-ui";
import en from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { locale: en });

import VueAwesomeSwiper from "vue-awesome-swiper";
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel,
  Scrollbar,
  Thumbs,
  Controller,
  EffectFade
} from "swiper";
// import style
import "swiper/swiper-bundle.css";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import VueSessionStorage from "vue-sessionstorage";
Vue.use(VueSessionStorage);
// Vue.use(stack);
Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel,
  Scrollbar,
  Thumbs,
  Controller,
  EffectFade
]);
Vue.use(VueAwesomeSwiper, { Navigation, Pagination, Thumbs });
Vue.prototype.$fn = fn;
Vue.prototype.$cf = cf;
Vue.use(_);
Vue.prototype._ = _;
